export default {"en-US": __webpack_public_path__ + "i18n/en-US.bfa1b3c4.i18next.json"};